export const dataMemoria = [
  {
    id: 1,
    titleItem: "1996",
    imgItem: "https://itetlax.org.mx/assets/img/memElect/1.jpg",
    linkItem: "https://itetlax.org.mx/assets/pdf/memElect/1.pdf",
  },
  {
    id: 2,
    titleItem: "1998",
    imgItem: "https://itetlax.org.mx/assets/img/memElect/2.jpg",
    linkItem: "https://itetlax.org.mx/assets/pdf/memElect/2.pdf",
  },
  {
    id: 3,
    titleItem: "2001",
    imgItem: "https://itetlax.org.mx/assets/img/memElect/3.jpg",
    linkItem: "https://itetlax.org.mx/assets/pdf/memElect/3.pdf",
  },
  {
    id: 4,
    titleItem: "2002",
    imgItem: "https://itetlax.org.mx/assets/img/memElect/4.jpg",
    linkItem: "https://itetlax.org.mx/assets/pdf/memElect/4.pdf",
  },
  {
    id: 5,
    titleItem: "2004",
    imgItem: "https://itetlax.org.mx/assets/img/memElect/5.jpg",
    linkItem: "https://itetlax.org.mx/assets/pdf/memElect/5.pdf",
  },
  {
    id: 6,
    titleItem: "2007",
    imgItem: "https://itetlax.org.mx/assets/img/memElect/6.jpg",
    linkItem: "https://itetlax.org.mx/assets/pdf/memElect/6.pdf",
  },
  {
    id: 7,
    titleItem: "2010",
    imgItem: "https://itetlax.org.mx/assets/img/memElect/7.jpg",
    linkItem: "https://itetlax.org.mx/assets/pdf/memElect/7.pdf",
  },
  {
    id: 8,
    titleItem: "2013",
    imgItem: "https://itetlax.org.mx/assets/img/memElect/8.jpg",
    linkItem: "https://itetlax.org.mx/assets/pdf/memElect/8.pdf",
  },
  {
    id: 9,
    titleItem: "2015 - 2016 / 2017",
    imgItem: "https://itetlax.org.mx/assets/img/memElect/9.jpg",
    linkItem: "https://itetlax.org.mx/assets/pdf/memElect/9.pdf",
  },
  {
    id: 10,
    titleItem: "2018",
    imgItem: "https://itetlax.org.mx/assets/img/memElect/10.jpg",
    linkItem: "https://itetlax.org.mx/assets/pdf/memElect/10.pdf",
  },
  {
    id: 11,
    titleItem: "2020 - 2021 Anexos",
    imgItem: "https://itetlax.org.mx/assets/img/memElect/11.1.png",
    linkItem: "/MemoriaElectoral20202021",
  },
  {
    id: 12,
    titleItem: "2020 - 2021",
    imgItem: "https://itetlax.org.mx/assets/img/memElect/11.jpg",
    linkItem: "https://itetlax.org.mx/assets/pdf/memElect/11.pdf",
  },
  {
    id: 13,
    titleItem: "2023 - 2024",
    imgItem: "https://itetlax.org.mx/assets/img/memElect/12.jpg",
    linkItem: "https://itetlax.org.mx/assets/pdf/memElect/12.pdf",
  },
];
